import * as React from 'react'
import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Search from '../../components/Search'

import NotFound from './NotFound'

const NotFoundScreen = () => {
  return (
    <>
      <Header position={{ xs: 'relative', lg: 'sticky' }}>
        <Search />
      </Header>
      <AnimatePresence mode="wait">
        <NotFound />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default NotFoundScreen
